import { Field, FastField } from 'formik';

import { BaseInput } from '../BaseInput/BaseInput';

export const InputWithIdField = ({ name, label, disabled = false, id }) => {
  // const Component = disabled !== undefined ? Field : FastField;
  // return (
  //   <Component
  //     component={BaseInput}
  //     id={id}
  //     name={name}
  //     label={label}
  //     disabled={disabled}
  //     autoComplete="new-email"
  //     data-testid={name}
  //   />
  // );

  return (
    <Field
      component={BaseInput}
      id={id}
      name={name}
      label={label}
      disabled={disabled}
      autoComplete="new-email"
      data-testid={name}
    />
  );
};

export default InputWithIdField;
